import { render, staticRenderFns } from "./importPolicyList.vue?vue&type=template&id=3cea57b4&scoped=true"
import script from "./importPolicyList.vue?vue&type=script&lang=js"
export * from "./importPolicyList.vue?vue&type=script&lang=js"
import style0 from "./importPolicyList.vue?vue&type=style&index=0&id=3cea57b4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cea57b4",
  null
  
)

export default component.exports